import { CommonRequestOptions, makeRequest } from '../makeRequest';

export type StepFormField = {
   field_revisionid: number;
   form_revisionid: number;
   field_guid: string;
   field_type: string;
   label: string;
   required?: boolean;
   placeholder?: string;
   textarea?: string;
   orderby?: number;
   options: { [key: string]: any };
};

export type StepForm = {
   stepid: number;
   form_revisionid: number;
   date: number;
   fields: StepFormField[];
};

export async function getStepForm(
   stepid: number,
   revisionId: number,
   { ...common }: CommonRequestOptions = {}
): Promise<StepForm> {
   return makeRequest('get', `/step_forms/stepid/${stepid}`, {
      query: {
         guide_revisionid: revisionId,
      },
      ...common,
   });
}
